import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MapsLayer from "../components/MapsLayer";

const MapsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Live Venue Map (UAE)" />

        {/* MapsLayer */}
        <MapsLayer />
      </MasterLayout>
    </>
  );
};

export default MapsPage;
